import Api from "../api";
let uri = '/api/ed/permiso';
let uriOpcion = '/api/ed/opcion/merge';

export const getPermisos = () => {
    return Api.getInstance().executeGetQuery(uri)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getPermisoRol = (data) => {
    return Api.getInstance().executeQuery(`${uri}/rol`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const createPermiso = (data) => {
    return Api.getInstance().executeQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const editPermiso = (data)  => {
    return Api.getInstance.executeUpdateQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const delPermiso = (data)  => {
    return Api.getInstance().executeDeleteQuery(uri, {data: data})
    .then(res => res)
    .catch(err => console.log(err));
}

export const createOpcion = (data) => {
    return Api.getInstance().executeQuery(uriOpcion, data)
    .then(res => res)
    .catch(err => console.log(err));
}



